import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();

export function setGuardianId(state, id) {
  cookies.set("guardian_id", id, null, "/");
  state.guardianId = id;
}

export function setGuardianRole(state, role) {
  cookies.set("guardian_role", role, null, "/");
  state.guardianId = role;
}

export function setLocations(state, locations) {
  state.locations = locations;
}

export function setLocationLogo(state, logo) {
  cookies.set("location_logo", logo, null, "/");
  state.locationLogo = logo;
}

export function setLocationName(state, name) {
  cookies.set("location_name", name, null, "/");
  state.locationName = name;
}

export const setAppName = (state, name) => {
  cookies.set("location_app_name", name, null, "/");
  state.appName = name;
};

export function registerError(state, payload) {
  state.error = true;
  state.errorMessage = payload;
}

export function cleanErrors(state) {
  state.error = false;
  state.errorMessage = "";
}

export function RESET(state) {
  state.locationId = "";
  state.locationName = "";
  state.locationAdmin = {};
  state.locationDelegates = [];
  state.locationUsers = [];
  state.guardianId = "";
  state.guardianRole = "";
  state.locations = [];
  state.locationLogo = "";
  state.appName = "";
  state.error = false;
  state.errorMessage = "";

  cookies.remove("location_logo");
  cookies.remove("location_name");
  cookies.remove("guardian_id");
  cookies.remove("guardian_role");
  cookies.remove("location_app_name");
}
